module.exports = __webpack_public_path__ + "img/syukyaku-gyoumu-001.ca4dbb8d.jpg";